module.exports = __webpack_public_path__ + "media/stylesheets/images/active_admin/close_sm-c6198d470db767800f07160133014ea5.svg";